import $ from 'jquery';

class SiemaDynamicTimer
{
    build(slider, container, time) {

        const action = (typeof slider.previousSlide != 'undefined') ? (slider.previousSlide > slider.currentSlide ? 'right' : 'left') : 'center';
        const visibles = $(container).find('li').slice(slider.currentSlide, (slider.currentSlide + slider.perPage));
        const monthLabel = visibles.find('.month').length ? visibles.find('.month') : false;
        const first = visibles.first();
        const last = visibles.last();
        const display = first.data('display');

        $(time).text(display);
        $(time).hide();

        if (!monthLabel) {

            $(container).find('li .month').hide();
            $(time).show();
        } else {

            $(container).find('li .month').show();

            const monthLabelParent = monthLabel.parent();
            const index = $(container).find('li').index(monthLabelParent);
            const difference = (action == 'right') ? (slider.currentSlide + slider.perPage) - index : index - slider.currentSlide;
            const hasFristEntryStaticMonth = first.find('.month').length > 0;

            if (difference >= 1) {

              $(time).show();
            }

            if (hasFristEntryStaticMonth) {

              $(container).find('li .month').hide();
              $(time).show();
            }
        }
    }
}

export default SiemaDynamicTimer = new SiemaDynamicTimer();



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/siema-dynamic-timer.js